import {Component, OnInit} from '@angular/core';
import {ICellRendererParams} from 'ag-grid-community';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {GridUtils} from '../../../../shared-utilities/utils-old/grid-utils-old/grid-utils';
import {Store} from '@ngrx/store';
import {IconsEnum} from '../../../shared-icons/models/icons.enum';

@Component({
    selector: 'app-cell-renderer-selected',
    templateUrl: './cell-renderer-selected.component.html',
    styleUrls: ['./cell-renderer-selected.component.scss'],
    standalone: false
})
export class CellRendererSelectedComponent implements ICellRendererAngularComp, OnInit {

  value: boolean;
  params: ICellRendererParams;
  colDefField: string;
  colDefFieldType: string;

  readonly icons: typeof IconsEnum = IconsEnum;

  constructor(private readonly store: Store) {
  }

  agInit(params: ICellRendererParams): void {
    this.params = params;
    this.colDefField = params.colDef.field;
    this.value = this.params.data[this.colDefField];
    this.syncNodeSelectionFromData();
  }

  ngOnInit(): void {
    this.colDefFieldType = typeof this.params.value;
    this.value = this.value as typeof this.params.value;
  }

  getValue(): string | number | boolean {
    return this.value;
  }

  onCheckBoxClick(): void {
    this.params = {...this.params};
    this.params.data = structuredClone(this.params.data);
    this.params.node.setSelected(!this.params.node.isSelected());
    this.value = !this.value;
    GridUtils.updateIsSelectedForSingleNgpItem(this.params.data, this.value, this.store);
  }

  refresh(params: ICellRendererParams): boolean {
    this.params = params;
    this.value = params.data[this.colDefField];
    this.syncNodeSelectionFromData();
    return true;
  }

  private syncNodeSelectionFromData(): void {
    if (this.params.data.isSelected === true && !this.params.node.isSelected()) {
      this.params.node.setSelected(true, false, 'api');
    } else if (this.params.data.isSelected === false && this.params.node.isSelected()) {
      this.params.node.setSelected(false, false, 'api');
    }
  }

}
